import React, { useState } from "react";
import {
  Grid,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack, Error } from "@mui/icons-material";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import GetInvoiceTable from "./reportTables/GetInvoiceTable.js";
import PoTable from "./reportTables/PoTable.js";
import { Tabs, Tab } from "@mui/material";
import PoBasedTable from "./reportTables/PoBasedTable.js";
import NoCompilanceBased from "./reportTables/NoCompilanceBased.js";

const useStyles = makeStyles(dashboardStyle);
const commentBox = {
  fontFamily: "DM Sans,sans-serif",
  fontWeight: "400",
  fontSize: "0.875rem",
  width: "100%",
  border: "1px solid #b4b4b4",
  borderRadius: "2px",
  resize: "none",
  overflow: "hidden",
  outline: "none",
  height: "40px",
  marginTop: "1px",
  color: "black",
};
const headersPOCompilance = [
  { label: "Vendor Code", key: "vendorCode" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "Invoice No", key: "invoiceNo" },
];
const headersPOBased = [
  { label: "Invoice No", key: "invoiceNo" },
  { label: "Invoice Date", key: "invoiceDate" },
  { label: "Invoice Amount", key: "invoiceAmount" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "PO No", key: "poNumber" },
];
const headersPONoBased = [
  { label: "Invoice No", key: "invoiceNo" },
  { label: "Invoice Date", key: "invoiceDate" },
  { label: "Invoice Amount", key: "invoiceAmount" },
  {label:"Invoice Type",key:"invoiceType"},
  { label: "Vendor Name", key: "vendorName" },
];

export default function PoReport() {
  const classes = useStyles();
  const navigate = useNavigate();
  // const [data, setData] = useState([]);
  // Separate data states for each tab
  const [dataCompilance, setDataCompilance] = useState([]);
  const [dataPOBased, setDataPOBased] = useState([]);
  const [dataNoPOBased, setDataNoPOBased] = useState([]);
  const [complianceDate , setComplianceDates ] = useState({
    startDate : "",
    endDate:""
  })
  
  const [loading, setLoading] = useState(false);
  const [sendloader, setSendloader] = useState(false);

  const [countNo, setCountNo] = React.useState(1); // Set default page to 0
  const [value, setValue] = useState(0); // State variable to track the currently selected tab

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      {" "}
      <>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={sendloader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Card style={{ marginLeft: "20px", }}>
          <div>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              start
              style={{ marginBottom: "2%" }}
            >
              <Tab label="Compilance Report" />
              <Tab label="PO Based" />
              <Tab label="NoN-PO Based" />
            </Tabs>

            {/* Content for each tab */}
            <div style={{ display: value === 0 ? 'block' : 'none' }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <PoTable
                  loading={loading}
                  setComplianceDates = {setComplianceDates}
                  setCountNo={setCountNo}
                  header={headersPOCompilance}
                  data={dataCompilance}
                  dropdownValue={"InvoiceStatus"}
                  setData={setDataCompilance}
                  setLoading={setLoading}
                />
              </Grid>
             </div>
            <div style={{ display: value === 1 ? 'block' : 'none' }}>
              <PoBasedTable
              complianceDate={complianceDate}
                loading={loading}
                setCountNo={setCountNo}
                header={headersPOBased}
                data={dataPOBased}
                dropdownValue={"InvoiceStatus"}
                setData={setDataPOBased}
                setLoading={setLoading}
              />
             </div>
            <div style={{ display: value === 2 ? 'block' : 'none' }}>
              <NoCompilanceBased
              complianceDate={complianceDate}
                loading={loading}
                setCountNo={setCountNo}
                header={headersPONoBased}
                data={dataNoPOBased}
                dropdownValue={"InvoiceStatus"}
                setData={setDataNoPOBased}
                setLoading={setLoading}
              />
            </div>
          </div>
        </Card>
      </>
    </div>
  );
}